import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsx mdx */

import DefaultLayout from "/Users/ats/Desktop/cartoon-mango/docz-app-with-algolia-search/node_modules/gatsby-theme-docz/src/base/Layout.js";
export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <h1 {...{
      "id": "deleting-data"
    }}>{`Deleting Data`}</h1>
    <h2 {...{
      "id": "-deleting-data-by-calling-api"
    }}>{`# Deleting data by calling api`}</h2>
    <pre><code parentName="pre" {...{}}>{`   Note:
 -Data will be deleted automatically in the reducer and also it handles all the states..such as error,infinte,loader..etc
`}</code></pre>
    <pre><code parentName="pre" {...{
        "className": "language-js"
      }}>{`const BASE_URL = "https://example.com/";

const DEMO_API_CONFIGURATION = {
  url: ({ id }) => \`\${BASE_URL}user/\${id}\`,
  method: "DELETE",
  responseStatusCode: [900],
  responseStatusCodeKey: "code",
  responseDataKey: "data",
  responseMessageKey: "status",
  errorMessageKey: "error",
};

DEMO_API_CONFIGURATION_CALL({
  task: {
    name: "Delete-Handler",
    key: "id",
    id: [2],
  },
  request: {
    params: { id: 2 },
  },
});
`}</code></pre>
    <pre><code parentName="pre" {...{}}>{`   Note:
   -It will remove that particular object in an array
`}</code></pre>
    <h2 {...{
      "id": "-deleting-key-in-an-object"
    }}>{`# Deleting key in an object`}</h2>
    <pre><code parentName="pre" {...{}}>{`   Note:
 -It is almost similar to update, but instead of updating particular key it will delete the particular key from the object
`}</code></pre>
    <pre><code parentName="pre" {...{
        "className": "language-js"
      }}>{`const BASE_URL = "https://example.com/";

const DEMO_API_CONFIGURATION = {
  url: ({ id }) => \`\${BASE_URL}user/\${id}\`,
  method: "DELETE",
  responseStatusCode: [900],
  responseStatusCodeKey: "code",
  responseDataKey: "data",
  responseMessageKey: "status",
  errorMessageKey: "error",
};

DEMO_API_CONFIGURATION_CALL({
  task: {
    name: "Delete-Key-Handler",
    id: [1, 2, 3],
    key: "id",
    deleteKey: ["name", "age"],
  },
  request: {
    params: { id: 1 },
  },
});
/* 
Example:

data = [ { id: 1, name: 'name1',age: '13',gender: 'male' },{ id: 1, name: 'name1',age: '12',gender: 'female' }]
After executing task:
data = [ { id: 1, gender: 'male' },{ id: 2, gender: 'female' }]
*/
`}</code></pre>
    <h2 {...{
      "id": "-manually-deleting-by-calling-custom-task"
    }}>{`# Manually Deleting by calling custom task`}</h2>
    <pre><code parentName="pre" {...{}}>{`     Note:
   -Calling custom task will allow us to manipulate data without calling any api..such as adding count,linit,skip..etc
`}</code></pre>
    <pre><code parentName="pre" {...{
        "className": "language-js"
      }}>{`import { HOC, commonConstants, store } from "react-boilerplate-redux-saga-hoc";

const { ON_SUCCESS } = commonConstants;
const { DEMO_API_CONFIGURATION_CUSTOM_TASK } = props;

DEMO_API_CONFIGURATION_CUSTOM_TASK(ON_SUCCESS, {
  task: {
    name: "Delete-Handler",
    id: [1, 2],
    key: "id",
  },
});
`}</code></pre>
    <h2 {...{
      "id": "-getting-data-from-store"
    }}>{`# Getting Data from store`}</h2>
    <pre><code parentName="pre" {...{
        "className": "language-js"
      }}>{`import { useMemo } from "react";
import { useQuery } from "react-boilerplate-redux-saga-hoc";
const {
  Auth_hoc: {
    reducerName,
    reducerConstants: { DEMO_API_CONFIGURATION },
  },
} = props;

const { loader, data, lastUpdated, isInfinite, infiniteEnd } = useQuery(
  reducerName,
  DEMO_API_CONFIGURATION
);
`}</code></pre>
    <p>{`Next - `}<a parentName="p" {...{
        "href": "/react-boilerplate-redux-saga-hoc-docs/docs/basic-concepts/adding-data-based-on-filters"
      }}>{`Adding Data based on filters`}</a></p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      